import { StaticPage } from '@dreamstack/accentro-contentful/src/components/StaticPage'
import { fetchStaticPageData } from '@dreamstack/payload/src/lib/fetchStaticPageData'
import { getStaticPropsPlus } from '../lib/next/getStaticPropsPlus'

export default function Home() {
  return (
    <>
      <StaticPage slug={'index'} />
    </>
  )
}

export const getStaticProps = getStaticPropsPlus({
  getProps: async () => {
    await fetchStaticPageData({ slug: 'index' })
  },
})
